import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [navbarMobile, setNavbarMobile] = useState(false);
  const [dropdownActive, setDropdownActive] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById('header');
      if (header) {
        if (window.scrollY > 100) {
          header.classList.add('header-scrolled');
        } else {
          header.classList.remove('header-scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileNav = () => {
    setNavbarMobile(!navbarMobile);
  };

  const handleDropdownClick = (e, id) => {
    e.preventDefault();
    setDropdownActive(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <header id="header" className={`fixed-top ${navbarMobile ? 'navbar-mobile' : ''}`}>
      <div className="container d-flex align-items-center justify-content-between">

        <h1 className="logo">
          <Link to="/">
            <img src="/logo.jpg" alt="Logo" />
          </Link>
        </h1>

        <nav id="navbar" className={`navbar ${navbarMobile ? 'navbar-mobile' : ''}`}>
          <ul>

            <li>
              <Link className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} to="/">
                Home
              </Link>
            </li>

            <li>
              <Link className={`nav-link ${location.pathname === '/specialalitychem' ? 'active' : ''}`} to="/specialalitychem">
                Speciality Chemicals
              </Link>
            </li>

            <li>
              <Link className={`nav-link ${location.pathname === '/bulk-drug' ? 'active' : ''}`} to="/bulk-drug">
                Bulk Drugs
              </Link>
            </li>

            {/* 🔽 Instruments Dropdown */}
            <li className={`dropdown ${dropdownActive['instruments'] ? 'dropdown-active' : ''}`}>
              <a href="#" onClick={(e) => handleDropdownClick(e, 'instruments')}>
                <span>Instruments</span> <i className="bx bx-chevron-down"></i>
              </a>

              <ul>

                {/* Pulp & Paper */}
                <li className={`dropdown ${dropdownActive['pulp-paper'] ? 'dropdown-active' : ''}`}>
                  <a href="#" onClick={(e) => handleDropdownClick(e, 'pulp-paper')}>
                    <span>Pulp & Paper</span>
                  </a>

                  <ul className="second-dropdown">
                    <li><Link to="/Pulp-Testing">Pulp Testing</Link></li>
                    <li><Link to="/Paper-Testing">Paper Testing</Link></li>
                    <li><Link to="/packainginstruments">Packaging Instruments</Link></li>
                  </ul>
                </li>

                {/* R&D Instruments */}
                <li className={`dropdown ${dropdownActive['rd'] ? 'dropdown-active' : ''}`}>
                  <a href="#" onClick={(e) => handleDropdownClick(e, 'rd')}>
                    <span>R&D Instruments</span>
                  </a>

                  <ul className="second-dropdown">
                    <li><Link to="/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight">Particle Size</Link></li>
                    <li><Link to="/RD-Instruments/zetapotetial">Zeta Potential</Link></li>
                    <li><Link to="/RD-Instruments/particle-charge-analyser/charge-analyser-system">Charge Analyser</Link></li>
                    <li><Link to="/RD-Instruments/melt-flow-index-tester">Melt Flow</Link></li>
                    <li><Link to="/RD-Instruments/sofast-bv3-viscometer">Viscometer</Link></li>
                    <li><Link to="/RD-Instruments/optical-probes">Optical Probes</Link></li>
                  </ul>
                </li>

                {/* Bio Engineering */}
                <li className={`dropdown ${dropdownActive['bio'] ? 'dropdown-active' : ''}`}>
                  <a href="#" onClick={(e) => handleDropdownClick(e, 'bio')}>
                    <span>Bio Engineering</span>
                  </a>

                  <ul className="second-dropdown">
                    <li><Link to="/bio-engineering/fermenters-bioreactorst">Fermenters</Link></li>
                    <li><Link to="/bio-engineering/partical-size-analyser">Particle Size</Link></li>
                  </ul>
                </li>

                <li><Link to="/rubber-polymer-industries">Rubber & Polymer</Link></li>
                <li><Link to="/instruments-materialtesting">Material Testing</Link></li>
                <li><Link to="/textileinstruments">Textile</Link></li>

              </ul>
            </li>

            <li><Link to="/services">Service</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/careers">Careers</Link></li>

            <li>
              <Link className="getstarted" to="/contact">Contact</Link>
            </li>

          </ul>

          <i
            className={`fa ${navbarMobile ? 'fa-times' : 'fa-bars'} mobile-nav-toggle`}
            onClick={toggleMobileNav}
          ></i>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;